import React from "react";
import "./layoutPlaybackPopup.scss";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useImmer } from "use-immer";

const formatTime = (time) => {
  if (!time) return null;
  return new Date(time).getTime();
};
function LayoutPlaybackPopup({ open, handleClose, handleSubmit, customerName }) {
  const [playbackPopForm, setPlaybackForm] = useImmer({ from_ts: null, to_ts: null });
  const [formError, setFormError] = useImmer({});
  const submit = () => {
    const tsObj = { from_ts: formatTime(playbackPopForm.from_ts), to_ts: formatTime(playbackPopForm.to_ts) };
    let errorObj = {};
    if (!tsObj.from_ts) {
      errorObj.from_ts = "Please Enter From Time";
    }
    if (!tsObj.to_ts) {
      errorObj.to_ts = "Please Enter To Time";
    }
    if (Object.keys(errorObj).length) {
      setFormError(errorObj);
      return;
    }
    handleSubmit(tsObj);
  };
  return (
    <Dialog className="playback-pop" open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle className="playback-pop-header">
        Historical Yard Simulator For {customerName}
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent className="playback-pop-content">
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          <DateTimePicker
            label="From Date-Time*"
            value={playbackPopForm.from_ts ?? null}
            onChange={(date) =>
              setPlaybackForm((prev) => {
                prev.from_ts = date;
              })
            }
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                error={formError?.from_ts ?? null}
                helperText={formError?.from_ts ?? ""}
                type="datetime-local"
              />
            )}
          />
          <DateTimePicker
            label="To Date-Time*"
            value={playbackPopForm.to_ts ?? null}
            onChange={(date) =>
              setPlaybackForm((prev) => {
                prev.to_ts = date;
              })
            }
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                error={formError?.to_ts ?? null}
                helperText={formError?.to_ts ?? ""}
                type="datetime-local"
              />
            )}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={handleClose} variant="outlined">
          Close
        </Button>
        <Button onClick={submit} size="small" variant="contained">
          Play
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LayoutPlaybackPopup;
